<template>
    <!-- Site footer -->
    <footer class="site-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <h6 style="padding:1em 0 0.5rem 0">About Us</h6>
            <p class="text-justify">WelcomeToNaija.com. Welcome To Naija is a tourist guide web application that is designed to help tourists gain interest in Nigeria.
                We provide tips on how to navigate Nigeria to make tourists who decide to come make their stay worthwhile.</p>
          </div>

          <div class="col-xs-6 col-md-3" style="padding:0rem 0 10px 0">
            <h6 style="padding:1.25rem 0 0.5rem 0">Services</h6>
            <ul class="footer-links">
              <li><router-link to="/places">Places</router-link></li>
              <li><router-link to="/accom">Accomodation Listings</router-link></li>
              <li><router-link to="/places">Recipes</router-link></li>
              <li><router-link to="/places">Blog</router-link></li>
            </ul>
          </div>
        </div>
        <hr>
      </div>
      <div class="container cs">
        <div class="row">
          <div class="col-md-8 col-sm-6 col-xs-12">
            <p class="copyright-text">Copyright &copy; 2022 All Rights Reserved by 
         <a href="#">Welcome To Naija</a>.
            </p>
          </div>

          <div class="col-md-4 col-sm-6 col-xs-12">
            <ul class="social-icons">
              <li><a class="facebook" href="#"><font-awesome-icon icon="fa-brands fa-facebook" /></a></li>
              <li><a class="twitter" href="#"><font-awesome-icon icon="fa-brands fa-twitter" /></a></li>
              <li><a class="linkedin" href="#"><font-awesome-icon icon="fa-brands fa-linkedin"/></a></li>   
            </ul>
          </div>
        </div>
      </div>
</footer>
</template>

<style scoped>
.site-footer
{
  background-color:#041010;
  padding:45px 0 20px;
  font-size:15px;
  line-height:24px;
  color:#737373;
}
.site-footer hr
{
  border-top-color:#bbb;
  opacity:0.5
}
.site-footer hr.small
{
  margin:20px 0
}
.site-footer h6
{
  color:#fff;
  font-size:16px;
  text-transform:uppercase;
  margin-top:5px;
  letter-spacing:2px
}
.site-footer a
{
  color:#737373;
}
.site-footer a:hover
{
  color:#3366cc;
  text-decoration:none;
}
.footer-links
{
  padding-left:0;
  list-style:none
}
.footer-links li
{
  display:block
}
.footer-links a
{
  color:#737373
}
.footer-links a:active,.footer-links a:focus,.footer-links a:hover
{
  color:#3366cc;
  text-decoration:none;
}
.footer-links.inline li
{
  display:inline-block
}
.site-footer .social-icons
{
  text-align:right
}
.site-footer .social-icons a
{
  width:40px;
  height:40px;
  line-height:40px;
  margin-left:6px;
  margin-right:0;
  border-radius:100%;
  background-color:#041010;
}
.copyright-text
{
  margin:0
}
@media (max-width:991px)
{
  .site-footer [class^=col-]
  {
    margin-bottom:30px
  }
}
@media (max-width:767px)
{
  .site-footer
  {
    padding-bottom:0
  }
  .site-footer .copyright-text,.site-footer .social-icons
  {
    text-align:center
  }
}
.social-icons
{
  padding-left:0;
  margin-bottom:0;
  list-style:none
}
.social-icons li
{
  display:inline-block;
  margin-bottom:4px
}
.social-icons li.title
{
  margin-right:15px;
  text-transform:uppercase;
  color:#96a2b2;
  font-weight:700;
  font-size:13px
}
.social-icons a{
  background-color:#eceeef;
  color:#818a91;
  font-size:16px;
  display:inline-block;
  line-height:44px;
  width:44px;
  height:44px;
  text-align:center;
  margin-right:8px;
  border-radius:100%;
  -webkit-transition:all .2s linear;
  -o-transition:all .2s linear;
  transition:all .2s linear
}
.social-icons a:active,.social-icons a:focus,.social-icons a:hover
{
  color:#fff;
  background-color:#29aafe
}
.social-icons.size-sm a
{
  line-height:34px;
  height:34px;
  width:34px;
  font-size:14px
}
.social-icons a.facebook:hover
{
  background-color:#3b5998
}
.social-icons a.twitter:hover
{
  background-color:#00aced
}
.social-icons a.linkedin:hover
{
  background-color:#007bb6
}
.social-icons a.dribbble:hover
{
  background-color:#ea4c89
}
@media (max-width:767px)
{
  .social-icons li.title
  {
    display:block;
    margin-right:0;
    font-weight:600
  }
}

.site-footer{
    margin:2rem;
    margin-top:0;
}

.cs{
    padding-bottom:1.25rem;
}
</style>